<script>
export default {
  functional: true,
  props: ['content'],
  render(createElement, context) {
    const { content } = context.props
    const showComponent = data =>
      data.condition !== undefined ? data.condition : true
    const getComponent = componentData =>
      createElement(
        componentData.component,
        {
          props: componentData.props,
          attrs: componentData.attrs,
          on: { ...componentData.listeners }
        },
        [
          componentData.innerText,
          componentData.children &&
            componentData.children
              .filter(showComponent)
              .map(data => getComponent(data))
        ]
      )
    if (showComponent(content)) {
      return getComponent(content)
    }
    return {}
  }
}
</script>
